<div class="d-flex justify-content-between align-items-center mb-3">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mt-2 mb-0">
      <li class="breadcrumb-item active" aria-current="page">
        <a [routerLink]="'/translation/translations'">Translations</a>
      </li>
      <li class="breadcrumb-item" aria-current="page">
        <span class="fs-5 fw-bold mb-0">{{ translationDomain?.domain }}</span>
      </li>
    </ol>
  </nav>

  <div (click)="openKnowledgeModal()" class="btn btn-info text-light"><i class="bi bi-bookmark-fill me-2"></i>Knowledge
  </div>
</div>

<div class="card border-0 shadow mb-3" [class.fade-in-zoom]="!errorAnchor">
  <div class="card-body">
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3">
      <h2 class="fw-bold fs-6 mb-0">{{ translationDomain?.description }}</h2>
      <button class="btn btn-primary fw-bold" (click)="translate()">Translate</button>
    </div>

    <div class="d-flex mb-5 align-items-center flex-wrap gap-2">
      <div class="me-1">
        <app-dropdown-select class="form-control" style="padding: 2px 20px !important;" [(ngModel)]="baseLocale"
                             (ngModelChange)="baseLocaleChanged()">
          @for (locale of availableLocales; track locale) {
            <app-dropdown-select-option [value]="locale">
              <img [ngSrc]="langService.getFlag(locale ?? '')" [alt]="locale" width="24"
                   height="24" class="me-1">
            </app-dropdown-select-option>
          }
        </app-dropdown-select>
      </div>
      @if (toLocales.length) {
        <div class="me-1"><i class="bi bi-arrow-right"></i></div>
      }
      @for (locale of toLocales; track locale) {
        <div class="btn btn-outline-primary btn-sm">
          <app-input-switch (change)="changeDisplayedLocale(locale??'', $event)"
                            [ngModel]="isDisplayedLocale(locale??'')">
            <img [ngSrc]="langService.getFlag(locale ?? '')" [alt]="locale" width="24"
                 height="24" class="me-1">
          </app-input-switch>
        </div>
      }
    </div>

    <div class="table-responsive">
      @if (!loader.isLoading()) {
        <table class="table">
          <thead>
          <tr>
            <th></th>
            @for (locale of displayedLocales; track locale) {
              <th [width]="getColumnsWidth()">
                @let missingTranslation = getMissingTranslations(locale);
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center me-1">
                    <div>
                      <img [ngSrc]="langService.getFlag(locale ?? '')" [alt]="locale" width="32" height="32"
                           class="me-1">
                      @if (missingTranslation) {
                        <span>⚠️ {{ missingTranslation }}</span>
                      }
                    </div>
                    <div>
                      <app-input-switch [(ngModel)]="reviewedLocales[locale]" (change)="onReview(locale)"
                                        onLabel="Reviewed" offLabel="Pending"></app-input-switch>
                    </div>
                  </div>
                  <div>
                    <button (click)="openSearchReplaceModal(locale)" class="btn btn-outline-info btn-sm me-2">
                      <i class="bi bi-search"></i>
                    </button>
                    @if (getPreviewUrl(locale)) {
                      <a [href]="getPreviewUrl(locale)" target="_blank"
                         class="btn btn-sm btn-outline-secondary"><i class="bi bi-eye"></i></a>
                    }
                  </div>
                </div>
              </th>
            }
          </tr>
          </thead>
          <tbody>
            @for (key of keys; track key) {
              <tr>
                <td class="fw-bold">{{ key.key }}</td>
                @for (locale of displayedLocales; track locale) {
                  <td class="text-wrap" [ngClass]="{hightlight: isHighlighted(key.key, locale)}">
                    <div [id]="locale+'-'+key.key"></div>
                    <app-translation-message-editor #editor [text]="$safeNavigationMigration(getKeyMessage(key.locales, locale)?.text)"
                                                    (textChange)="updateMessage(key.key, locale, $event, editor)"
                                                    (textFocus)="reloadMessage(key.key, editor)"
                    >
                    </app-translation-message-editor>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
